export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

import { getUserRole } from '../../utils/userRoleUtils'

// Don't call getUserRole at module load time - it will be called when needed
const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'recruiter-dashboard',
      displayName: 'Recruiter Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-pending',
      displayName: 'Pending Review',
      meta: {
        icon: 'pending',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'documents-reviewed',
      displayName: 'Documents Reviewed',
      meta: {
        icon: 'check_circle',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-booked',
      displayName: 'Training Booked',
      meta: {
        icon: 'event_available',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-approved',
      displayName: 'Approved',
      meta: {
        icon: 'verified',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-accepted',
      displayName: 'Accepted',
      meta: {
        icon: 'check_circle',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-active',
      displayName: 'Active Drivers',
      meta: {
        icon: 'directions_car',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'applicant-rejected',
      displayName: 'Rejected',
      meta: {
        icon: 'cancel',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'training-schedule',
      displayName: 'Training Management',
      meta: {
        icon: 'school',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'messages',
      displayName: 'Messages',
      meta: {
        icon: 'message',
        allowedRoles: ['recruiter'],
      },
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['recruiter'],
      },
    },
  ],
}

export default sidebarRoutes
